import { InterventionTemplate } from "@/types/intervention-template";
import { deleteData, getData, postData, putData } from "./axios-service";

function interventionTemplateMapper(inputInterventionTemplate: any): InterventionTemplate {
    return {
        id: inputInterventionTemplate.id,
        productType: inputInterventionTemplate.productType,
        items: inputInterventionTemplate.items || []

    };
}

export function interventionTemplateMapperArray(inputArray: any[]): InterventionTemplate[] {
    return inputArray.map(interventionTemplateMapper);
}


export async function postInterventionTemplate(template: InterventionTemplate): Promise<InterventionTemplate> {
    const response = await postData("/intervention-templates", template);
    return interventionTemplateMapper(response);
}

export async function fetchInterventionTemplates(): Promise<InterventionTemplate[]> {
    const templates  = await getData<InterventionTemplate[]>("/intervention-templates");
    return interventionTemplateMapperArray(templates ?? []);
}

export function fetchInterventionTemplateById(id: string): Promise<InterventionTemplate> {
    return getData("/intervention-templates/" + id).then(
        onSucceed => {
            return interventionTemplateMapper(onSucceed);
        }
    );
}

export function putInterventionTemplate(template: InterventionTemplate): Promise<any> {
    return putData("/intervention-templates/" + template.id, template);
}

export function deleteInterventionTemplate(id: string): Promise<any> {
    return deleteData("/intervention-templates/" + id);
}
